module.exports = __webpack_public_path__ + "static/media/Profile3.bd64dae2.svg";